// Notifications for the REST interface
export type NotificationFilterBody = {
  userId: string;
  status?: NotificationStatus;
  notificationIds?: string[];
};

export type NotificationStatusChangeMessage = NotificationFilterBody & {
  action: Action;
};

export type NotificationMessageBody = {
  userId: string;
  messages: NotificationMessage[];
};

export type NotificationMessage = {
  id: string;
  title: string;
  content: string;
  url: string;
  newTab: boolean;
  creationDate: string;
  status: NotificationStatus;
};

export enum Action {
  GET = 'GET',
  UPDATE = 'UPDATE',
}

export interface NotificationResponseBody {
  userId: string;
  notificationMessages: NotificationMessage[];
}

export interface NotificationSubscriptionStatusSettings {
  email: boolean;
  bell: boolean;
  category: string;
  forwarding: {
    enabled: boolean;
    targetUserId?: string;
    startDate?: string;
    endDate?: string;
  };
}

export interface NotificationSubscriptionStatusResponseBody {
  userId: string;
  settings: NotificationSubscriptionStatusSettings[];
}

export interface EmployeeListForNotificationsResponseBody {
  employees: [
    {
      userId: string;
      name: string;
    },
  ];
}

export interface EmployeeItem {
  label: string;
  value: string;
}

export enum NotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
  DELETED = 'DELETED',
}

export enum NotificationEventContext {
  READ = 'READ',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}

export interface WsStatusMessage {
  id: string;
  status: NotificationStatus;
}

export interface WsNotification {
  to: string;
  from: string;
  statusMessages: WsStatusMessage[];
  eventContext: NotificationEventContext;
}
